import { render } from "./appActivityInfo.vue?vue&type=template&id=3d65ff5d&scoped=true"
import script from "./appActivityInfo.vue?vue&type=script&lang=js"
export * from "./appActivityInfo.vue?vue&type=script&lang=js"

import "./appActivityInfo.vue?vue&type=style&index=0&id=3d65ff5d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d65ff5d"]])

export default __exports__